// extracted by mini-css-extract-plugin
export var lg = "_p-4";
export var md = "_p-3";
export var sm = "_p-2";
export var xs = "_p-1";
export var xxs = "_p-0";